import Timer from './timer.js';

const gameEndSound = data_handler.gameEndSound;
const audio = new Audio('https://bluebird.ac/Sound_Game_over.mp3');

const gameState = data_handler.gameState,
	linkGameLostPage = data_handler.linkGameLostPage;

const DOMElements = {
	bodyElement: 'body',
	gameEndAlertModul: '#gameEndAlertModul',
	progress: '#progress',
	backToGameBtn: '#backToGameBtn',
	toGameEndBtn: '#toGameEndBtn',
};

const bodyElement = document.querySelector(DOMElements.bodyElement),
	gameEndAlertModul = document.querySelector(DOMElements.gameEndAlertModul),
	progress = document.querySelector(DOMElements.progress),
	backToGameBtn = document.querySelector(DOMElements.backToGameBtn),
	toGameEndBtn = document.querySelector(DOMElements.toGameEndBtn);

const closeOverlay = () => {
	bodyElement.classList.remove('activemenu');
	gameEndAlertModul.classList.remove('active');
	progress.classList.remove('active');
};

const pageRedirect = () => {
	window.location.replace(linkGameLostPage);
};

const EndGameAlert = {
	bindEvents: () => {
		if (backToGameBtn) {
			backToGameBtn.addEventListener('click', closeOverlay);
		}
		if (toGameEndBtn) {
			toGameEndBtn.addEventListener('click', pageRedirect);
		}
	},
	watchTimeLeft: () => {
		if (gameState === 'game_running') {
			const x = setInterval(function () {
				const distance = Timer.timeDistance();
				if (distance < 6) {
					EndGameAlert.alertGameEnd();
					if (gameEndSound === 'on') {
						audio.play();
					}
					clearInterval(x);
				}
			}, 1000);
		}
	},
	alertGameEnd: () => {
		bodyElement.classList.add('activemenu');
		if (gameEndAlertModul) {
			gameEndAlertModul.classList.add('active');
		}
		if (progress) {
			progress.classList.add('active');
		}
	},
};

export default EndGameAlert;
